import { render, staticRenderFns } from "./ModalThemThongTinDonVi.vue?vue&type=template&id=6997076b&"
import script from "./ModalThemThongTinDonVi.vue?vue&type=script&lang=js&"
export * from "./ModalThemThongTinDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports